import { useEffect, useState } from "react";

export function useHitCounter(imagePaths: string[]) {
  const [hitCounts, setHitCounts] = useState<Record<string, number>>({});

  useEffect(() => {
    const storedCounts = localStorage.getItem("hitCounts");
    if (storedCounts) {
      try {
        setHitCounts(JSON.parse(storedCounts));
      } catch {
        console.warn("hitCounts inválido no localStorage");
      }
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("hitCounts", JSON.stringify(hitCounts));
  }, [hitCounts]);

  const incrementHit = (imagePath: string) => {
    setHitCounts((counts) => ({
      ...counts,
      [imagePath]: (counts[imagePath] || 0) + 1,
    }));
  };

  const resetHits = () => {
    const confirmed = window.confirm(
      "Tem a certeza de que pretende repor toda a contagem de acertos?",
    );
    if (!confirmed) return;

    setHitCounts(() => {
      const newCounts: Record<string, number> = {};
      imagePaths.forEach((path) => {
        newCounts[path] = 0;
      });
      return newCounts;
    });
  };

  return { hitCounts, incrementHit, resetHits };
}
